import { PureLightTheme } from "../../../styles/theme"
import { COLORS } from "../../../styles/variables"

export const CardHeader = {
  borderRadius: '0',
  borderBottom: `1px solid ${COLORS.LINK_WATER}`,
  boxShadow: 'none',
}

export const ContainerHeader = {
  display: 'flex',
  alignItems: 'center',
  height: '60px',
  maxWidth: '1112px',
  [PureLightTheme.breakpoints.down('lg')]: {
    padding: '0px 30px',
  }
  // '@media (max-width: 1170px)': {
  //   paddingLeft: '30px',
  //   paddingRight: '30px',
  // },
}

export const BoxHeaderLogo = {
  marginRight: 4.5,
  height: '30px',
}

export const ButtonLogin = {
  borderRadius: '16px',
  padding: '8px 16px',
  fontWeight: 600,
  fontSize: '14px',
}
